import { OnDemandWebinarsPage } from '@online-webinar/public';
import { RouterType } from '@online-webinar/router';

export const updateRoute = (router: RouterType) => {
    router.routesById['/on-demand'].update({
        staticData: { title: { page: 'Title.OnDemand' } },
        component: OnDemandWebinarsPage
    });
};
